<template>
  <div>
    <span
      class="engagement-badge"
      :class="props.model.engaged ? 'engaged' : 'not-engaged'"
    >
      {{ props.model.engaged ? 'Engaged' : 'Not Engaged' }}
    </span>
  </div>
</template>



<script lang="ts" setup>
import GripLink from '~/components/GripLink.vue';
import { defineProps, ref, inject } from 'vue';
import type { ColumnDataSchemaModel } from '@revolist/vue3-datagrid';

const props = defineProps<ColumnDataSchemaModel>();
const EngagementCell = ref<HTMLElement>();

const message = inject('sample');
function customCellClickEvent() {
  console.log('Custom cell click > Injected message:', message);
  const event = new CustomEvent('cell-custom-action', {
    bubbles: true,
    detail: { row: props.model },
  });
  EngagementCell.value?.dispatchEvent(event);
}
</script>


<style scoped>
.engagement-badge {
  display: inline;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.93rem;
  font-weight: 600;
}
.engaged {
  background: #d1fae5;
  color: #047857;
}
.not-engaged {
  background: #fee2e2;
  color: #b91c1c;
}
</style>